import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-question-damage-image-right-back-fender',
    templateUrl: './question-damage-image-right-back-fender.component.html',
    styleUrls: ['./question-damage-image-right-back-fender.component.scss'],
    standalone: false
})
export class QuestionDamageImageRightBackFenderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
